import { Box, Typography } from '@mui/material'
import React from 'react'

const Members = () => {
  return (
    <Box sx={{m:2}}><Typography variant='h3'>Members</Typography></ Box>
  )
}

export default Members